import { create } from 'zustand';
import { persist } from 'zustand/middleware';

/** @typedef {'sidebar' | 'widget'} AssistantLayoutPreference */
/** @typedef {'sprite' | 'avatar'} AgentDisplayStylePreference */

const useUIPreferenceStore = create(
  persist(
    (set) => ({
      /** @type {AssistantLayoutPreference} */
      assistantLayout: 'widget',
      setAssistantLayout: (assistantLayout) => set({ assistantLayout }),
      /** @type {AgentDisplayStylePreference} */
      agentDisplayStyle: 'sprite',
      setAgentDisplayStyle: (agentDisplayStyle) => set({ agentDisplayStyle }),
    }),
    {
      name: 'ui-preferences',
      version: 1,
      migrate: (persistedState) => {
        if (!persistedState || typeof persistedState !== 'object') {
          return persistedState;
        }

        if (persistedState.agentDisplayStyle) {
          return persistedState;
        }

        if (persistedState.widgetLauncherStyle) {
          return {
            ...persistedState,
            agentDisplayStyle: persistedState.widgetLauncherStyle,
          };
        }

        return persistedState;
      },
      partialize: (state) => ({
        assistantLayout: state.assistantLayout,
        agentDisplayStyle: state.agentDisplayStyle,
      }),
    }
  )
);

export default useUIPreferenceStore;
